export const GET_STUDENTS_PAGE_SIZE = 100;
export const TRANSACTION_HISTORY_TABLE_PAGE_SIZE = 10;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/helpers/Constants.js